<script setup>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  product: {
    type: Object,
    default: null,
  },
  deleting: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close", "confirm"]);

function closeDialog() {
  if (props.deleting) return;
  emit("close");
}

function confirmDelete() {
  emit("confirm", props.product);
}
</script>

<template>
  <Dialog
    :visible="props.visible"
    modal
    header="Удаление товара"
    :style="{ width: 'min(420px, 95vw)' }"
    :closable="!props.deleting"
    @update:visible="closeDialog"
  >
    <div class="content">
      <p>
        Вы уверены, что хотите удалить товар
        <b>{{ props.product?.name }}</b
        >?
      </p>

      <p class="warning">Это действие нельзя отменить.</p>
    </div>

    <template #footer>
      <Button
        label="Отмена"
        severity="secondary"
        outlined
        :disabled="props.deleting"
        @click="closeDialog"
      />

      <Button
        label="Удалить"
        icon="pi pi-trash"
        severity="danger"
        :loading="props.deleting"
        :disabled="props.deleting"
        @click="confirmDelete"
      />
    </template>
  </Dialog>
</template>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.warning {
  color: #ef4444;
  font-size: 14px;
}
</style>
